
const RENAME_FILE = 'RENAME_FILE';

export default {
    RENAME_FILE,
};
